// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WgDQK{min-width:0;overflow:hidden}.Vxv2T{min-width:0;overflow:hidden}.h8Lxi.h8Lxi{flex:none;width:32px;height:32px;box-sizing:border-box}.s1fyA{flex:none;align-self:center}.iEasT{position:absolute;top:50%;right:11px;transform:translateY(-50%)}.iEasT .AWxsL{height:32px}.CdI2B{min-width:0;overflow:hidden}.OaBd5{flex:none;max-width:100%}.A_OII{min-width:0;width:100%;position:relative}._DRGW{position:absolute;visibility:hidden;pointer-events:none;white-space:nowrap;display:flex;gap:6px}.hdrBD{white-space:normal;overflow-wrap:anywhere}.lv_BW{width:100%}.lv_BW input{border:1px solid transparent;border-radius:4px}.lv_BW input:hover{border-color:#d4d4e0}.lv_BW input:focus:enabled{outline:none;border-color:#6942f8}.AWxsL{flex:none;align-self:center;padding:0 12px;border:1px solid transparent;border-radius:8px;background:transparent}.AWxsL.AI95_{padding-inline-start:4px}.AWxsL.gt1mV{padding-inline-end:4px}.AWxsL.tUGKp{padding:0;border:0}.ZvZpo{white-space:nowrap;text-decoration:none;padding:0}.ZvZpo:hover,.ZvZpo:focus{text-decoration:none;color:#4520cc}.NfSR0{height:20px}.pM8lP.pM8lP{width:24px;height:24px;min-width:24px;padding:4px;border-radius:4px}.pM8lP.pM8lP:hover,.pM8lP.pM8lP:focus-visible{background:#f4f4f7}.kGZ9k{text-decoration:none}.ymzih.ymzih{background:#a58efb;color:#fff;border:1px solid #e1d9fe;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em}.jDRZw{position:absolute;top:0;right:12px;bottom:0;left:12px;align-content:safe center;overflow-y:auto}.DWMMl{display:inline-flex;align-items:center;min-width:0}.DWMMl+.DWMMl::before{content:"·";padding-inline:4px;color:#7e7ea1}.YfSTO{position:relative;margin-left:-4px;flex:1;width:100%;min-width:0;height:24px}.YfSTO.btwl2 input{padding-right:28px}.cCvrp{position:absolute;right:2px;top:50%;transform:translateY(-50%);z-index:1}.gbmyn{flex:1;justify-content:inherit;min-width:0;white-space:nowrap}.exVQM{display:flex;align-items:center;justify-content:inherit;min-width:0;max-width:100%;padding:0;border:none;border-radius:4px;background:none;font:inherit;color:inherit;text-align:inherit;cursor:pointer}.exVQM:hover{outline:1px solid #d4d4e0;outline-offset:2px}.exVQM:focus-visible{outline:1px solid #6942f8;outline-offset:2px}.NvhQ7{flex-shrink:0}.pabRR{min-width:0;overflow:hidden}.S9KVj{flex:none;width:16px;height:16px;border-radius:50%}.HYbSn{margin:0;padding-block:8px;list-style:disc inside}.s2LR3{line-height:1.2}.rgkyT{display:inline-flex;align-items:center;gap:4px;min-height:20px;vertical-align:middle}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"stacked": `WgDQK`,
	"identity": `Vxv2T`,
	"avatar": `h8Lxi`,
	"actions": `s1fyA`,
	"rowActions": `iEasT`,
	"actionsPill": `AWxsL`,
	"tagChips": `CdI2B`,
	"tagChip": `OaBd5`,
	"tagChipsHost": `A_OII`,
	"tagChipsMeasure": `_DRGW`,
	"multiline": `hdrBD`,
	"editor": `lv_BW`,
	"startsWithKebab": `AI95_`,
	"endsWithKebab": `gt1mV`,
	"loneCardIcon": `tUGKp`,
	"primaryAction": `ZvZpo`,
	"actionsDivider": `NfSR0`,
	"kebabButton": `pM8lP`,
	"link": `kGZ9k`,
	"initialsAvatar": `ymzih`,
	"linkLines": `jDRZw`,
	"linkItem": `DWMMl`,
	"editorHost": `YfSTO`,
	"withTokenAdornment": `btwl2`,
	"tokenTrigger": `cCvrp`,
	"money": `gbmyn`,
	"editableValue": `exVQM`,
	"unit": `NvhQ7`,
	"dotted": `pabRR`,
	"dot": `S9KVj`,
	"listCell": `HYbSn`,
	"listItem": `s2LR3`,
	"listItemContent": `rgkyT`
};
export default ___CSS_LOADER_EXPORT___;
